import React from 'react';

import defaultConfig from '@config/environments/default';
import development from '@config/environments/development';
import production from '@config/environments/production';
import staging from '@config/environments/staging';
import test from '@config/environments/test';

import { isClient } from './is-client';

const CONFIG_MAPPING = {
  production: production,
  staging: staging,
  test: test,
};

export type config = typeof defaultConfig;

export const factoryConfig = () => {
  if (isClient) return { ...defaultConfig };

  const APP_ENV = process.env.APP_ENV as
    | keyof typeof CONFIG_MAPPING
    | undefined;

  let config = { ...defaultConfig };
  if (APP_ENV && APP_ENV in CONFIG_MAPPING) {
    config = {
      ...config,
      ENV: APP_ENV,
      ...CONFIG_MAPPING[APP_ENV],
    };
  } else {
    config = { ...config, ENV: 'development', ...development };
  }

  return config;
};

export const ConfigEnsurer = () => {
  if (isClient) return null;

  const __html = `window._runtimeConfig = ${JSON.stringify(factoryConfig())}`;
  return <script dangerouslySetInnerHTML={{ __html }} />;
};
